// src/components/battle/CourseSearchSection.jsx
// 돋보기를 누르면 "내 코스 리스트"가 쭈르륵 뜨고
// 코스를 클릭하면 상단 입력 칸이 그 값으로 채워지는 컴포넌트

import { useState } from "react";
import { listMyCoursesForBattle } from "../../api/battleCourseApi";
import { HiOutlineMagnifyingGlass } from "react-icons/hi2";

const WS_INPUT =
  "w-full rounded-xl border border-slate-200 bg-white px-4 py-3.5 text-sm " +
  "outline-none placeholder:text-slate-400 " +
  "focus:border-[rgb(0,224,198)] focus:ring-2 focus:ring-[rgb(0,224,198)]/20";

export default function CourseSearchSection({
  selectedCourseId,
  selectedCourseName,
  onCourseSelect,
}) {
  // TODO: 로그인 붙으면 실제 로그인 사용자로 교체
  const userId = localStorage.getItem("userId");

  const [courseList, setCourseList] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // 🔍 돋보기 클릭 시 : 리스트 열기 + (처음이면) 서버에서 내 코스 조회
  const handleClickSearch = async () => {
    // 열고/닫기 토글
    const nextOpen = !open;
    setOpen(nextOpen);

    // 처음 열 때만 서버 호출
    if (!nextOpen || courseList.length > 0) {
      return;
    }

    try {
      setLoading(true);

      const res = await listMyCoursesForBattle(userId);
      const rawList = res.data || [];

      // ✅ "내 공개 러닝 코스"만 필터링 (거리조건 제거)
      const availableOnly = rawList.filter((course) => {
        // 1) 공개 여부 (VO: boolean isPublic)
        // - 응답이 boolean이면 그대로 사용
        // - 혹시 서버/매퍼 영향으로 0/1 또는 "0"/"1"로 내려와도 방어
         const p = course?.public ?? course?.isPublic;
        const isPublic =
          p === true || p === 1 || p === "1" || p === "Y" || p === "y";

        // 2) 러닝 타입 (RUN / RUNNING / 러닝)
        const t = (course?.type || "").toString().trim().toUpperCase();
        const isRunning =
          t === "RUN" || t === "RUNNING" || t === "러닝";

        return isPublic && isRunning;
      });

      setCourseList(availableOnly);
    } catch (e) {
      console.error("내 코스 리스트 조회 실패:", e);
      setCourseList([]);
    } finally {
      setLoading(false);
    }
  };

  // 리스트에서 코스 선택
  const handleSelectCourse = (course) => {
    if (onCourseSelect) {
      onCourseSelect(course); // 👉 AddBattlePage에서 ID/이름 상태 변경
    }
    setOpen(false); // 선택 후 리스트 닫기
  };

  return (
    <section className="ws-section ws-section-battle-course mb-4 text-sm">
      {/* 상단 : 선택된 코스명 + 돋보기 버튼 */}
      <div className="flex items-center gap-3 mb-2">
        <input
          className={`flex-1 ${WS_INPUT}`}
          placeholder="코스를 선택해 주세요."
          value={selectedCourseName || ""}
          readOnly
        />

        <button
          type="button"
          onClick={handleClickSearch}
          className="
            w-12 h-[46px]
            flex items-center justify-center
            rounded-xl
            border border-slate-200
            bg-white
            shadow-sm
            text-slate-700
            hover:bg-slate-50
            transition
          "
          aria-label="코스 검색"
        >
          <HiOutlineMagnifyingGlass className="w-5 h-5" />
        </button>
      </div>

      <div className="text-xs text-slate-500 mb-2">
        {selectedCourseId
          ? `선택된 코스 ID : ${selectedCourseId}`
          : "선택된 코스 없음"}
      </div>

      {/* 아래 코스 리스트 영역 */}
      {open && (
        <div className="ws-card ws-card-course-list rounded-2xl border border-slate-100 bg-white shadow-sm max-h-60 overflow-y-auto">
          {loading && (
            <div className="px-4 py-3 text-xs text-slate-500">
              코스 목록을 불러오는 중...
            </div>
          )}

          {!loading && courseList.length === 0 && (
            <div className="px-4 py-3 text-xs text-slate-500">
              공개 러닝 코스가 없습니다.
            </div>
          )}

          {!loading &&
            courseList.length > 0 &&
            courseList.map((course) => (
              <div
                key={course.courseId}
                className={`px-4 py-3 text-sm cursor-pointer hover:bg-slate-50 ${
                  selectedCourseId === course.courseId
                    ? "bg-slate-50 font-semibold"
                    : ""
                }`}
                onClick={() => handleSelectCourse(course)}
              >
                <div className="text-slate-900">{course.courseName}</div>
                <div className="text-xs text-slate-500 mt-1">
                  {/* 코스 VO에 맞게 정보 표시 (필드명은 백엔드에 맞춰 수정) */}
                  거리: {course.distance}km / 난이도: {course.level}
                </div>
              </div>
            ))}
        </div>
      )}
    </section>
  );
}
